"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var bp = {
  xs: '480px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1600px'
};
function getWidth(_a) {
  var width = _a.width,
    padding = _a.padding,
    gutter = _a.gutter,
    n = _a.n;
  return "calc((" + width + "px - ( 2 * " + padding + "px) - ((" + (n - 1) + ") * " + gutter + "px)) / " + n + ")";
}
function getHeight(_a) {
  var width = _a.width,
    padding = _a.padding,
    gutter = _a.gutter,
    n = _a.n,
    ratio = _a.ratio,
    filler = _a.filler;
  return filler ? "1px" : "calc(((" + width + "px - ( 2 * " + padding + "px) - ((" + (n - 1) + ") * " + gutter + "px)) / " + n + ") * " + ratio + ")";
}
var StyledList = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 0 ", ";\n  @media screen and (min-width: ", ") {\n    padding: 0 ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: 0 ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: 0 ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: 0 ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: 0 ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: 0 ", ";\n  }\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 0 ", ";\n  @media screen and (min-width: ", ") {\n    padding: 0 ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: 0 ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: 0 ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: 0 ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: 0 ", ";\n  }\n  @media screen and (min-width: ", ") {\n    padding: 0 ", ";\n  }\n"])), function (_a) {
  var config = _a.config;
  return config.xxs.padding + "px";
}, bp.xs, function (_a) {
  var config = _a.config;
  return config.xs.padding + "px";
}, bp.sm, function (_a) {
  var config = _a.config;
  return config.sm.padding + "px";
}, bp.md, function (_a) {
  var config = _a.config;
  return config.md.padding + "px";
}, bp.lg, function (_a) {
  var config = _a.config;
  return config.lg.padding + "px";
}, bp.xl, function (_a) {
  var config = _a.config;
  return config.xl.padding + "px";
}, bp.xxl, function (_a) {
  var config = _a.config;
  return config.xxl.padding + "px";
});
var StyledItem = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  @media screen and (min-width: ", ") {\n    width: ", ";\n    height: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    width: ", ";\n    height: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    width: ", ";\n    height: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    width: ", ";\n    height: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    width: ", ";\n    height: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    width: ", ";\n    height: ", ";\n  }\n"], ["\n  width: ", ";\n  height: ", ";\n  @media screen and (min-width: ", ") {\n    width: ", ";\n    height: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    width: ", ";\n    height: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    width: ", ";\n    height: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    width: ", ";\n    height: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    width: ", ";\n    height: ", ";\n  }\n  @media screen and (min-width: ", ") {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (_a) {
  var width = _a.width,
    config = _a.config;
  return getWidth({
    width: width,
    padding: config.xxs.padding,
    gutter: config.xxs.gutter,
    n: config.xxs.n
  });
}, function (_a) {
  var width = _a.width,
    config = _a.config,
    filler = _a.filler;
  return getHeight({
    width: width,
    padding: config.xxs.padding,
    gutter: config.xxs.gutter,
    n: config.xxs.n,
    ratio: config.xxs.ratio,
    filler: filler
  });
}, bp.xs, function (_a) {
  var width = _a.width,
    config = _a.config;
  return getWidth({
    width: width,
    padding: config.xs.padding,
    gutter: config.xs.gutter,
    n: config.xs.n
  });
}, function (_a) {
  var width = _a.width,
    config = _a.config,
    filler = _a.filler;
  return getHeight({
    width: width,
    padding: config.xs.padding,
    gutter: config.xs.gutter,
    n: config.xs.n,
    ratio: config.xs.ratio,
    filler: filler
  });
}, bp.sm, function (_a) {
  var width = _a.width,
    config = _a.config;
  return getWidth({
    width: width,
    padding: config.sm.padding,
    gutter: config.sm.gutter,
    n: config.sm.n
  });
}, function (_a) {
  var width = _a.width,
    config = _a.config,
    filler = _a.filler;
  return getHeight({
    width: width,
    padding: config.sm.padding,
    gutter: config.sm.gutter,
    n: config.sm.n,
    ratio: config.sm.ratio,
    filler: filler
  });
}, bp.md, function (_a) {
  var width = _a.width,
    config = _a.config;
  return getWidth({
    width: width,
    padding: config.md.padding,
    gutter: config.md.gutter,
    n: config.md.n
  });
}, function (_a) {
  var width = _a.width,
    config = _a.config,
    filler = _a.filler;
  return getHeight({
    width: width,
    padding: config.md.padding,
    gutter: config.md.gutter,
    n: config.md.n,
    ratio: config.md.ratio,
    filler: filler
  });
}, bp.lg, function (_a) {
  var width = _a.width,
    config = _a.config;
  return getWidth({
    width: width,
    padding: config.lg.padding,
    gutter: config.lg.gutter,
    n: config.lg.n
  });
}, function (_a) {
  var width = _a.width,
    config = _a.config,
    filler = _a.filler;
  return getHeight({
    width: width,
    padding: config.lg.padding,
    gutter: config.lg.gutter,
    n: config.lg.n,
    ratio: config.lg.ratio,
    filler: filler
  });
}, bp.xl, function (_a) {
  var width = _a.width,
    config = _a.config;
  return getWidth({
    width: width,
    padding: config.xl.padding,
    gutter: config.xl.gutter,
    n: config.xl.n
  });
}, function (_a) {
  var width = _a.width,
    config = _a.config,
    filler = _a.filler;
  return getHeight({
    width: width,
    padding: config.xl.padding,
    gutter: config.xl.gutter,
    n: config.xl.n,
    ratio: config.xl.ratio,
    filler: filler
  });
}, bp.xxl, function (_a) {
  var width = _a.width,
    config = _a.config;
  return getWidth({
    width: width,
    padding: config.xxl.padding,
    gutter: config.xxl.gutter,
    n: config.xxl.n
  });
}, function (_a) {
  var width = _a.width,
    config = _a.config,
    filler = _a.filler;
  return getHeight({
    width: width,
    padding: config.xxl.padding,
    gutter: config.xxl.gutter,
    n: config.xxl.n,
    ratio: config.xxl.ratio,
    filler: filler
  });
});
function ResponsiveList(props) {
  var _a = props.items,
    items = _a === void 0 ? [] : _a,
    renderItem = props.renderItem,
    _b = props.config,
    config = _b === void 0 ? {
      xxs: {
        n: 1,
        padding: 20,
        gutter: 0,
        ratio: 1
      },
      xs: {
        n: 2,
        padding: 10,
        gutter: 10,
        ratio: 1.2
      },
      sm: {
        n: 3,
        padding: 15,
        gutter: 10,
        ratio: 1.3
      },
      md: {
        n: 4,
        padding: 20,
        gutter: 15,
        ratio: 1.4
      },
      lg: {
        n: 5,
        padding: 20,
        gutter: 10,
        ratio: 1.5
      },
      xl: {
        n: 6,
        padding: 20,
        gutter: 10,
        ratio: 1.8
      },
      xxl: {
        n: 7,
        padding: 20,
        gutter: 10,
        ratio: 2
      },
      style: {
        borderRadius: 10,
        backgroundColor: 'mediumseagreen',
        marginBottom: 5
      }
    } : _b;
  var container = react_1.useRef(null);
  var _c = react_1.useState(null),
    width = _c[0],
    setWidth = _c[1];
  react_1.useLayoutEffect(function () {
    var listener = function () {
      setWidth(container.current.offsetWidth);
    };
    window.addEventListener('resize', listener);
    return function () {
      window.removeEventListener('resize', listener);
    };
  }, []);
  return react_1.default.createElement(StyledList, {
    config: config,
    ref: function (node) {
      if (node && !width) {
        container.current = node;
        setWidth(node.offsetWidth);
      }
    }
  }, items.map(function (item, i) {
    return react_1.default.createElement(StyledItem, {
      style: config.style,
      key: i,
      width: width || 0,
      config: config
    }, renderItem(item));
  }), new Array(config.xxl.n).fill(0).map(function (f, i) {
    return react_1.default.createElement(StyledItem, {
      key: i,
      filler: true,
      width: width || 0,
      config: config
    });
  }));
}
exports.default = ResponsiveList;
var templateObject_1, templateObject_2;